const ROUTES = {
  HOME: '/',
  CUSTOMER_EXPERIENCE: '/customer_experience',
}

export default ROUTES
